module.exports = __webpack_public_path__ + "img/container_img06.775147bd.png";